import {
  Button,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Link,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import { IRegistrationsProps } from '../../../../services/hooks/CandidateArea/useRequestMyRegistration';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { ContextAuth } from '../../../../contexts/Authentication';
import AnswerSheetModal from './AnswerSheetModal';
import TafAdaptationModal from './TafAdaptationModal';

const TAF_ADAPTATION_PROCESS_KEY = 'physical_aptitude_test_process';

interface IActionsList {
  registrationData: IRegistrationsProps;
  selectiveProcessId: string;
  isLegacy?: boolean;
  allowFilterVacancyTree?: boolean;
}

const ActionList: React.FC<IActionsList> = ({
  selectiveProcessId,
  registrationData,
  isLegacy,
  allowFilterVacancyTree,
}) => {
  const [confirmationText, setConfirmationText] = useState('');
  const isConfirmEnabled = confirmationText.trim().toUpperCase() === 'CANCELAR';
  const { candidate, isMobile } = useContext(ContextAuth);
  const navigate = useNavigate();
  const { isOpen, onClose } = useDisclosure();
  const { isOpen: isAnswerSheetOpen, onOpen: onAnswerSheetOpen, onClose: onAnswerSheetClose } = useDisclosure();
  const { isOpen: isTafAdaptationOpen, onOpen: onTafAdaptationOpen, onClose: onTafAdaptationClose } = useDisclosure();

  const { registration_id, actions, announcement_stages_convocations } = registrationData;

  const handleCancelRegistration = (regId: string) => {
    console.log(regId);
  };

  return (
    <>
      <UnorderedList maxW="300px" styleType="'> '" color="colorLink">
        {actions?.has_matriculation && (
          <Stack mt={isMobile ? 3 : 0} ml={-3} w="calc(100% + 15px)" p={0} mb={2}>
            <Link href={actions?.has_matriculation} target="_blank">
              <Button w="100%" p={2} m={0} mb={1} h={'fit-content'} fontSize="13px" colorScheme="green">
                Realizar matrícula
              </Button>
            </Link>

            <Divider borderColor="black" />
          </Stack>
        )}
        {/* <ListItem onClick={() => onOpen()} cursor="pointer">
          <Text>Cancelar inscrição</Text>
        </ListItem> */}
        <ListItem
          onClick={() => navigate(`/painel/inscricao/${registration_id}`, { state: registration_id })}
          cursor="pointer"
        >
          <Text>Detalhes da inscrição</Text>
        </ListItem>
        {actions?.can_update_registration && allowFilterVacancyTree && (
          <ListItem
            onClick={() =>
              navigate(
                `/processo-seletivo/${selectiveProcessId}/inscricao/${registration_id}/documentos-vaga?from=candidate`,
              )
            }
            cursor="pointer"
          >
            <Text>Modificar documentos obrigatórios</Text>
          </ListItem>
        )}
        {isLegacy && actions?.has_result ? (
          <ListItem onClick={() => navigate(`/processo-seletivo/resultado/${registration_id}`)} cursor="pointer">
            <Text>Resultados</Text>
          </ListItem>
        ) : (
          !isLegacy &&
          actions?.has_result && (
            <ListItem
              onClick={() => navigate(`/processo-seletivo/resultado-etapas/${registration_id}`)}
              cursor="pointer"
            >
              <Text>Resultados</Text>
            </ListItem>
          )
        )}
        {/* {actions?.has_result && (
          <ListItem onClick={() => navigate(`/processo-seletivo/resultado-etapas/${registration_id}`)} cursor="pointer">
            <Text>Resultados</Text>
          </ListItem>
        )} */}
        {actions.convocation_titles_process && (
          <ListItem
            onClick={() =>
              navigate(`/painel/${registration_id}/etapa/${actions.convocation_titles_process}/prova-titulos`)
            }
            cursor="pointer"
          >
            <Text>Prova de títulos - formulário de envio</Text>
          </ListItem>
        )}
        {announcement_stages_convocations
          ?.filter((item) => item.candidate_allocation_id != null && item.process_key !== TAF_ADAPTATION_PROCESS_KEY)
          .map((item) => (
            <ListItem
              key={item.id}
              onClick={() =>
                navigate(
                  `/painel/local-de-prova/${registration_id}/convocacao/alocacao/${item.candidate_allocation_id}`,
                )
              }
              cursor="pointer"
            >
              <Text>{item.convocation_field_caption || item.name}</Text>
            </ListItem>
          ))}
        {actions?.convocation_delivery_project_documentation_materials_process && (
          <ListItem
            onClick={() =>
              navigate(
                `/painel/${registration_id}/etapa/${actions?.convocation_delivery_project_documentation_materials_process}/projeto`,
              )
            }
            cursor="pointer"
          >
            <Text>Enviar o projeto de pesquisa para a defesa de projeto</Text>
          </ListItem>
        )}
        {actions?.speciall_condition && (
          <ListItem
            cursor="pointer"
            whiteSpace="break-spaces"
            onClick={() => navigate(`/painel/condicao-especial/${registration_id}/${selectiveProcessId}`)}
          >
            <Text>Solicitação de atendimento especial</Text>
          </ListItem>
        )}
        {actions?.show_pppiq_form && (
          <ListItem cursor="pointer" onClick={() => navigate(`/painel/pppiq?registration=${registration_id}`)}>
            <Text>Formulário de envio de comprovação - PPPIQ</Text>
          </ListItem>
        )}
        {announcement_stages_convocations
          ?.filter((item) => {
            if (!item.receive_self_declaration_documents) return false;
            const now = new Date();
            const start = item.receive_self_declaration_documents_start
              ? new Date(item.receive_self_declaration_documents_start)
              : null;
            const end = item.receive_self_declaration_documents_end
              ? new Date(item.receive_self_declaration_documents_end)
              : null;
            return (!start || now >= start) && (!end || now <= end);
          })
          .map((item) => (
            <ListItem
              key={`pppiq-${item.id}`}
              cursor="pointer"
              onClick={() => navigate(`/painel/pppiq?registration=${registration_id}`)}
            >
              <Text>{item.convocation_field_caption}</Text>
            </ListItem>
          ))}
        {announcement_stages_convocations
          ?.filter((item) => {
            if (item.process_key !== TAF_ADAPTATION_PROCESS_KEY) return false;
            const now = new Date();
            const start = item.window_start ? new Date(item.window_start) : null;
            const end = item.window_end ? new Date(item.window_end) : null;
            return (!start || now >= start) && (!end || now <= end);
          })
          .map((item) => (
            <ListItem key={`taf-adaptation-${item.id}`} cursor="pointer" onClick={onTafAdaptationOpen}>
              <Text>{item.convocation_field_caption}</Text>
            </ListItem>
          ))}
        {actions?.can_update_registration && (
          <ListItem
            cursor="pointer"
            onClick={() =>
              navigate(
                `/processo-seletivo/${selectiveProcessId}/editar-inscricao/${registration_id}?previousRoute=/painel`,
              )
            }
          >
            <Text>Modificar dados da inscrição</Text>
          </ListItem>
        )}
        {actions?.second_billing_statement && (
          <ListItem cursor="pointer" onClick={() => navigate(`/painel/segunda-via-cobranca/${registration_id}`)}>
            <Text>Emitir boleto de cobrança</Text>
          </ListItem>
        )}
        {registrationData?.candidate_attachments &&
          registrationData.candidate_attachments.length > 0 &&
          registrationData.candidate_attachments.map((attachment, index) => {
            const isAnswerSheet =
              attachment.document_name === 'Espelho da folha resposta' ||
              attachment.document_name === 'Relatório de leitura da folha resposta';
            return (
              <ListItem
                key={`attachment-${index}`}
                cursor="pointer"
                onClick={isAnswerSheet ? onAnswerSheetOpen : undefined}
              >
                {isAnswerSheet ? (
                  <Text>{attachment.document_name}</Text>
                ) : (
                  <Link href={attachment.file_url} target="_blank" rel="noopener noreferrer">
                    <Text>{attachment.document_name}</Text>
                  </Link>
                )}
              </ListItem>
            );
          })}

        <AnswerSheetModal isOpen={isAnswerSheetOpen} onClose={onAnswerSheetClose} registrationId={registration_id} />

        <TafAdaptationModal
          isOpen={isTafAdaptationOpen}
          onClose={onTafAdaptationClose}
          registrationId={registration_id}
        />
      </UnorderedList>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent pb={10} maxW={['80%', '80%', '80%', '40%', '40%']} maxH="none">
          <ModalHeader textAlign="center">CANCELAMENTO DA INSCRIÇÃO</ModalHeader>
          <ModalCloseButton />

          <ModalBody display="flex" flexDir="column" gap={1}>
            <Stack>
              <Stack>
                <Text color="red.600" fontWeight="bold">
                  Atenção: esta ação é irreversível!
                </Text>
                <Text>
                  Ao confirmar o cancelamento, sua inscrição será permanentemente removida deste processo seletivo. Você
                  perderá todos os dados relacionados à sua candidatura e não poderá recuperá-la depois. Certifique-se
                  de que esta é realmente a ação que deseja realizar.
                </Text>
              </Stack>

              <Stack mb={10}>
                <Text>
                  <strong>Nome completo:</strong> {candidate?.user?.full_name}
                </Text>
                <Text>
                  <strong>{candidate?.is_foreign ? 'Passaporte' : 'CPF'}:</strong>{' '}
                  {candidate?.is_foreign ? candidate.passport_number : candidate?.cpf}
                </Text>
                <Text>
                  <strong>Nome da vaga:</strong> {registrationData?.vacancy_name}
                </Text>

                <Text>
                  <strong>Situação da inscrição:</strong> {registrationData?.status}
                </Text>
              </Stack>

              <FormControl>
                <FormLabel fontSize="13px">
                  Digite <strong>CANCELAR</strong> para confirmar
                </FormLabel>
                <Input
                  placeholder="Digite CANCELAR"
                  value={confirmationText}
                  onChange={(e) => setConfirmationText(e.target.value)}
                />
                {!isConfirmEnabled && (
                  <FormHelperText fontSize="13px" color="red.500">
                    Você precisa digitar exatamente CANCELAR para prosseguir.
                  </FormHelperText>
                )}
              </FormControl>

              <Button
                onClick={() => handleCancelRegistration(registration_id)}
                colorScheme="red"
                isDisabled={!isConfirmEnabled}
              >
                Cancelar inscrição
              </Button>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ActionList;
